import { TOGGLE_THEME } from '../types/themeConstants';

export default function toggleTheme() {
  return {
    type: TOGGLE_THEME,
  };
}
